// Copyright (c) 2016 Deere & Company

import './warranty-modal.scss';
import React, {PropTypes} from 'react';
import {LargeModal} from 'deere-ui-modal-core';

const WarrantyXlargeModal = props => {

    const simpleClass = props.simple ?
        'simple' : '';

    return (
        <LargeModal
            {...props}
            className={`warranty-xlarge-modal ${simpleClass}`}
            transitionEnterTimeout={500}
            transitionLeaveTimeout={500}
        />
    );

};

WarrantyXlargeModal.displayName = 'WarrantyXlargeModal';
WarrantyXlargeModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    simple: PropTypes.bool
};

export default WarrantyXlargeModal;



// WEBPACK FOOTER //
// ./src/shared/components/modal/xlarge-modal.js